const buildAddressInput = formValues => ({
  user: {
    email: formValues.email.value,
    password: formValues.password.value,
    firstname: formValues.firstname.value,
    lastname: formValues.lastname.value,
    title: formValues.title.value,
    jobTitle: formValues.jobTitle.value,
    company: formValues.company.value,
    industry: formValues.industry.value,
    tel: formValues.tel.value,
    tocAccepted: formValues.tocAccepted.value
  },
  address: {
    firstname: formValues.firstname.value,
    lastname: formValues.lastname.value,
    company: formValues.company.value,
    address1: formValues.address1.value,
    address2: formValues.address2.value,
    city: formValues.city.value,
    postcode: formValues.postcode.value,
    country: formValues.country.value,
    county: formValues.county.value,
    tel: formValues.tel.value
  }
});

export default buildAddressInput;
